import React from 'react';
import t from 'babel-plugin-yate/macro';
import cuid from 'cuid';

import Icon from '../Icons';
import Label from './Label';
import ValidationError from './ValidationError';
import Note from './Note';

export function Select({
  input,
  children,
  loadingData,
  label = undefined,
  id = cuid(),
  meta: {touched, error, note},
  disabled = undefined,
  required = undefined,
  placeholder = undefined,
  ...rest
}) {
  return (
    <>
      {label && <Label value={label} target={id} />}

      <div className="relative">
        <select
          {...input}
          {...rest}
          id={id}
          required={required}
          disabled={disabled}
          placeholder={placeholder}
          className={`block appearance-none border rounded w-full py-3 px-4
                  text-grey-darker text-14 opacity-100 ${
                    error && touched ? 'border-red' : 'border-grey'
                  } ${disabled ? 'pl-8 bg-grey-4 bg-opacity-50 cursor-not-allowed' : 'bg-white'}`}>
          {!loadingData ? children : t`Loading`}
        </select>

        {disabled && (
          <div className="absolute top-0 mt-3 ml-2 text-grey-darker-1 cursor-not-allowed">
            <Icon name="Lock" />
          </div>
        )}

        {loadingData && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 999,
              overflowY: 'auto',
              padding: 3,
            }}>
            <div className="spinner" />
          </div>
        )}

        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-grey-darker-1">
          <svg
            className="fill-current inline h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>

      {note && <Note value={note} />}
      {error && touched && <ValidationError value={error} />}
    </>
  );
}
